/**
 * 微信网页授权（snsapi_base）与后端的统一点：
 * - redirectUrl 须与「立即授权」传给 /api/wechat/authorize?redirectUrl= 的完全一致
 * - OAUTH_STATE 须与后端 wechat.oauth-state（WechatAuthServiceImpl，见 application-prod.yml）一致；其余微信参数在库表 wechat_config
 * - 开发环境请通过 devServer 代理访问 /api，使授权跳转与 getOpenid 命中同一套后端
 */

/**
 * 与后端 WechatAuthServiceImpl 中 @Value wechat.oauth-state 保持同步（改后端时请同步此常量或配 VUE_APP）
 */
export const OAUTH_STATE =
  (typeof process !== 'undefined' && process.env && process.env.VUE_APP_WECHAT_OAUTH_STATE) ||
  '123'

/** 审核结果入口：跳转授权前标记；由 AuthCallback 读取 */
export const VISITOR_OPEN_AUDIT_AFTER_OAUTH = 'visitor_open_audit_after_oauth'

/** 授权前 window.location.hash，用于回跳恢复页面 */
export const VISITOR_OAUTH_RETURN_HASH = 'visitor_oauth_return_hash'

/** 授权成功且需自动打开审核弹层；App.vue afterEach 消费后删除 */
export const VISITOR_PENDING_OPEN_AUDIT_PANEL = 'visitor_pending_open_audit_panel'

export function isWeixinBrowser () {
  return /micromessenger/i.test(navigator.userAgent || '')
}

/**
 * 授权完成回跳的 H5 地址（与微信公众平台「授权回调域」下页面一致，含 path/query/hash 须完全匹配已登记规则）
 * @returns {string}
 */
export function buildOAuthRedirectUrl () {
  return `${window.location.origin}/?wechat_auth=1#/auth-callback`
}

/**
 * 与当前页面同源，使 /api 在开发环境经 vue.config 代理、生产环境同源，与 getOpenid 使用同一套后端
 * @returns {string}
 */
export function getWechatSpaBase () {
  return window.location.origin
}

/**
 * 跳转至后端 /api/wechat/authorize，由后端 302 到微信 open.weixin.qq.com
 */
export function goWechatAuthorize () {
  const redirectUrl = buildOAuthRedirectUrl()
  const apiBase = getWechatSpaBase()
  window.location.href = `${apiBase}/api/wechat/authorize?redirectUrl=${encodeURIComponent(redirectUrl)}`
}
